// Centralized area-to-coordinates mapping for Malaysia

export const MALAYSIA_LOCATIONS = [
  // Kuala Lumpur
  {
    name: "Bukit Bintang",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1478, longitude: 101.7103 },
  },
  {
    name: "KLCC",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1579, longitude: 101.7116 },
  },
  {
    name: "Chow Kit",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1636, longitude: 101.6976 },
  },
  {
    name: "Brickfields",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1292, longitude: 101.6841 },
  },
  {
    name: "Bangsar",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1287, longitude: 101.6781 },
  },
  {
    name: "Mont Kiara",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1679, longitude: 101.6534 },
  },
  {
    name: "Desa ParkCity",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1895, longitude: 101.6272 },
  },
  {
    name: "Sri Petaling",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.0673, longitude: 101.6882 },
  },
  {
    name: "Cheras",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1072, longitude: 101.7242 },
  },
  {
    name: "Kepong",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.2127, longitude: 101.6381 },
  },
  {
    name: "Sentul",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1843, longitude: 101.6917 },
  },
  {
    name: "Wangsa Maju",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.2045, longitude: 101.7335 },
  },
  {
    name: "Setapak",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1979, longitude: 101.7126 },
  },
  {
    name: "Titiwangsa",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1789, longitude: 101.7056 },
  },
  {
    name: "Setiawangsa",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1782, longitude: 101.7451 },
  },
  {
    name: "Ampang",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1485, longitude: 101.7613 },
  },
  {
    name: "Taman Tun Dr Ismail",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1432, longitude: 101.6291 },
  },
  {
    name: "Damansara",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1425, longitude: 101.63 },
  },
  {
    name: "Sri Hartamas",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1623, longitude: 101.6508 },
  },
  {
    name: "Segambut",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1865, longitude: 101.6679 },
  },
  {
    name: "Jalan Ipoh",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1802, longitude: 101.6831 },
  },
  {
    name: "Jalan Kuching",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1884, longitude: 101.6743 },
  },
  {
    name: "Mid Valley",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1187, longitude: 101.6778 },
  },
  {
    name: "KL Sentral",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1344, longitude: 101.6865 },
  },
  {
    name: "Desa Sri Hartamas",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.1627, longitude: 101.6483 },
  },
  {
    name: "Bukit Jalil",
    area: "Kuala Lumpur",
    coordinates: { latitude: 3.0589, longitude: 101.6924 },
  },

  // Selangor
  {
    name: "Petaling Jaya",
    area: "Selangor",
    coordinates: { latitude: 3.1073, longitude: 101.6067 },
  },
  {
    name: "Subang Jaya",
    area: "Selangor",
    coordinates: { latitude: 3.0486, longitude: 101.5855 },
  },
  {
    name: "Shah Alam",
    area: "Selangor",
    coordinates: { latitude: 3.0733, longitude: 101.5185 },
  },
  {
    name: "Klang",
    area: "Selangor",
    coordinates: { latitude: 3.0449, longitude: 101.4456 },
  },
  {
    name: "Puchong",
    area: "Selangor",
    coordinates: { latitude: 2.9935, longitude: 101.6214 },
  },
  {
    name: "Cheras",
    area: "Selangor",
    coordinates: { latitude: 3.0785, longitude: 101.7502 },
  },
  {
    name: "Kajang",
    area: "Selangor",
    coordinates: { latitude: 2.9926, longitude: 101.7895 },
  },
  {
    name: "Ampang",
    area: "Selangor",
    coordinates: { latitude: 3.1485, longitude: 101.7613 },
  },
  {
    name: "Selayang",
    area: "Selangor",
    coordinates: { latitude: 3.2435, longitude: 101.6548 },
  },
  {
    name: "Kepong",
    area: "Selangor",
    coordinates: { latitude: 3.2127, longitude: 101.6381 },
  },
  {
    name: "Putrajaya",
    area: "Selangor",
    coordinates: { latitude: 2.9264, longitude: 101.6964 },
  },
  {
    name: "Seri Kembangan",
    area: "Selangor",
    coordinates: { latitude: 3.0234, longitude: 101.7058 },
  },
  {
    name: "Sepang",
    area: "Selangor",
    coordinates: { latitude: 2.6912, longitude: 101.7497 },
  },
  {
    name: "Bangi",
    area: "Selangor",
    coordinates: { latitude: 2.9171, longitude: 101.7699 },
  },
  {
    name: "Rawang",
    area: "Selangor",
    coordinates: { latitude: 3.3224, longitude: 101.5739 },
  },
  {
    name: "Batu Caves",
    area: "Selangor",
    coordinates: { latitude: 3.2374, longitude: 101.6841 },
  },
  {
    name: "Serdang",
    area: "Selangor",
    coordinates: { latitude: 3.0249, longitude: 101.7083 },
  },
  {
    name: "Ara Damansara",
    area: "Selangor",
    coordinates: { latitude: 3.1141, longitude: 101.5719 },
  },
  {
    name: "Damansara",
    area: "Selangor",
    coordinates: { latitude: 3.1425, longitude: 101.63 },
  },
  {
    name: "Damansara Perdana",
    area: "Selangor",
    coordinates: { latitude: 3.1668, longitude: 101.6062 },
  },
  {
    name: "Damansara Damai",
    area: "Selangor",
    coordinates: { latitude: 3.1979, longitude: 101.5947 },
  },
  {
    name: "Damansara Utama",
    area: "Selangor",
    coordinates: { latitude: 3.1349, longitude: 101.6224 },
  },
  {
    name: "Kota Kemuning",
    area: "Selangor",
    coordinates: { latitude: 3.0011, longitude: 101.5333 },
  },
  {
    name: "Sunway",
    area: "Selangor",
    coordinates: { latitude: 3.0706, longitude: 101.6074 },
  },
  {
    name: "USJ",
    area: "Selangor",
    coordinates: { latitude: 3.0441, longitude: 101.5836 },
  },
  {
    name: "Cyberjaya",
    area: "Selangor",
    coordinates: { latitude: 2.9213, longitude: 101.6517 },
  },
  {
    name: "Semenyih",
    area: "Selangor",
    coordinates: { latitude: 2.9482, longitude: 101.8431 },
  },
  {
    name: "Hulu Langat",
    area: "Selangor",
    coordinates: { latitude: 3.1118, longitude: 101.8219 },
  },
  {
    name: "Kuala Selangor",
    area: "Selangor",
    coordinates: { latitude: 3.3411, longitude: 101.2494 },
  },
  {
    name: "Tanjung Karang",
    area: "Selangor",
    coordinates: { latitude: 3.4265, longitude: 101.1738 },
  },
  {
    name: "Jenjarom",
    area: "Selangor",
    coordinates: { latitude: 2.8765, longitude: 101.4975 },
  },
  {
    name: "Banting",
    area: "Selangor",
    coordinates: { latitude: 2.8139, longitude: 101.5019 },
  },
  {
    name: "Morib",
    area: "Selangor",
    coordinates: { latitude: 2.75, longitude: 101.4428 },
  },
  {
    name: "Sabak Bernam",
    area: "Selangor",
    coordinates: { latitude: 3.7681, longitude: 100.9858 },
  },
  {
    name: "Sekinchan",
    area: "Selangor",
    coordinates: { latitude: 3.5064, longitude: 101.1017 },
  },
  {
    name: "Kelang Lama",
    area: "Selangor",
    coordinates: { latitude: 3.0851, longitude: 101.6728 },
  },

  // Johor
  {
    name: "Johor Bahru",
    area: "Johor",
    coordinates: { latitude: 1.4927, longitude: 103.7414 },
  },
  {
    name: "Iskandar Puteri",
    area: "Johor",
    coordinates: { latitude: 1.4275, longitude: 103.6494 },
  },
  {
    name: "Pasir Gudang",
    area: "Johor",
    coordinates: { latitude: 1.4731, longitude: 103.9017 },
  },
  {
    name: "Muar",
    area: "Johor",
    coordinates: { latitude: 2.0441, longitude: 102.5689 },
  },
  {
    name: "Batu Pahat",
    area: "Johor",
    coordinates: { latitude: 1.8548, longitude: 102.9325 },
  },
  {
    name: "Skudai",
    area: "Johor",
    coordinates: { latitude: 1.5469, longitude: 103.6622 },
  },
  {
    name: "Kluang",
    area: "Johor",
    coordinates: { latitude: 2.0251, longitude: 103.3328 },
  },
  {
    name: "Segamat",
    area: "Johor",
    coordinates: { latitude: 2.5137, longitude: 102.8158 },
  },
  {
    name: "Mersing",
    area: "Johor",
    coordinates: { latitude: 2.4312, longitude: 103.8405 },
  },
  {
    name: "Pontian",
    area: "Johor",
    coordinates: { latitude: 1.4868, longitude: 103.3881 },
  },
  {
    name: "Kulai",
    area: "Johor",
    coordinates: { latitude: 1.6641, longitude: 103.5998 },
  },
  {
    name: "Senai",
    area: "Johor",
    coordinates: { latitude: 1.5916, longitude: 103.6482 },
  },
  {
    name: "Tampoi",
    area: "Johor",
    coordinates: { latitude: 1.5034, longitude: 103.7061 },
  },
  {
    name: "Masai",
    area: "Johor",
    coordinates: { latitude: 1.4883, longitude: 103.8845 },
  },
  {
    name: "Kota Tinggi",
    area: "Johor",
    coordinates: { latitude: 1.7303, longitude: 103.9004 },
  },
  {
    name: "Desaru",
    area: "Johor",
    coordinates: { latitude: 1.5458, longitude: 104.2638 },
  },
  {
    name: "Gelang Patah",
    area: "Johor",
    coordinates: { latitude: 1.4461, longitude: 103.5872 },
  },
  {
    name: "Nusajaya",
    area: "Johor",
    coordinates: { latitude: 1.4285, longitude: 103.6147 },
  },
  {
    name: "Larkin",
    area: "Johor",
    coordinates: { latitude: 1.4952, longitude: 103.7335 },
  },
  {
    name: "Pelangi",
    area: "Johor",
    coordinates: { latitude: 1.4789, longitude: 103.7719 },
  },
  {
    name: "Tebrau",
    area: "Johor",
    coordinates: { latitude: 1.5284, longitude: 103.7634 },
  },

  // Penang
  {
    name: "George Town",
    area: "Penang",
    coordinates: { latitude: 5.4141, longitude: 100.3288 },
  },
  {
    name: "Butterworth",
    area: "Penang",
    coordinates: { latitude: 5.3991, longitude: 100.3636 },
  },
  {
    name: "Bayan Lepas",
    area: "Penang",
    coordinates: { latitude: 5.2851, longitude: 100.2595 },
  },
  {
    name: "Bukit Mertajam",
    area: "Penang",
    coordinates: { latitude: 5.3636, longitude: 100.4557 },
  },
  {
    name: "Gelugor",
    area: "Penang",
    coordinates: { latitude: 5.3744, longitude: 100.3061 },
  },
  {
    name: "Tanjung Tokong",
    area: "Penang",
    coordinates: { latitude: 5.4513, longitude: 100.3053 },
  },
  {
    name: "Tanjung Bungah",
    area: "Penang",
    coordinates: { latitude: 5.4666, longitude: 100.2798 },
  },
  {
    name: "Batu Ferringhi",
    area: "Penang",
    coordinates: { latitude: 5.4749, longitude: 100.2465 },
  },
  {
    name: "Air Itam",
    area: "Penang",
    coordinates: { latitude: 5.4024, longitude: 100.2825 },
  },
  {
    name: "Balik Pulau",
    area: "Penang",
    coordinates: { latitude: 5.3522, longitude: 100.2411 },
  },
  {
    name: "Kepala Batas",
    area: "Penang",
    coordinates: { latitude: 5.5171, longitude: 100.4265 },
  },
  {
    name: "Sungai Jawi",
    area: "Penang",
    coordinates: { latitude: 5.1974, longitude: 100.4938 },
  },
  {
    name: "Nibong Tebal",
    area: "Penang",
    coordinates: { latitude: 5.1695, longitude: 100.4777 },
  },
  {
    name: "Perai",
    area: "Penang",
    coordinates: { latitude: 5.3813, longitude: 100.3855 },
  },
  {
    name: "Seberang Jaya",
    area: "Penang",
    coordinates: { latitude: 5.3929, longitude: 100.3986 },
  },
  {
    name: "Bertam",
    area: "Penang",
    coordinates: { latitude: 5.5186, longitude: 100.4418 },
  },
  {
    name: "Sg. Ara",
    area: "Penang",
    coordinates: { latitude: 5.3263, longitude: 100.2731 },
  },
  {
    name: "Prai",
    area: "Penang",
    coordinates: { latitude: 5.3813, longitude: 100.3855 },
  },

  // Perak
  {
    name: "Ipoh",
    area: "Perak",
    coordinates: { latitude: 4.5975, longitude: 101.0901 },
  },
  {
    name: "Taiping",
    area: "Perak",
    coordinates: { latitude: 4.8517, longitude: 100.7336 },
  },
  {
    name: "Kampar",
    area: "Perak",
    coordinates: { latitude: 4.3031, longitude: 101.1555 },
  },
  {
    name: "Teluk Intan",
    area: "Perak",
    coordinates: { latitude: 4.0259, longitude: 101.0213 },
  },
  {
    name: "Manjung",
    area: "Perak",
    coordinates: { latitude: 4.195, longitude: 100.665 },
  },
  {
    name: "Lumut",
    area: "Perak",
    coordinates: { latitude: 4.2323, longitude: 100.6294 },
  },
  {
    name: "Sitiawan",
    area: "Perak",
    coordinates: { latitude: 4.2155, longitude: 100.6972 },
  },
  {
    name: "Batu Gajah",
    area: "Perak",
    coordinates: { latitude: 4.4759, longitude: 101.0413 },
  },
  {
    name: "Kuala Kangsar",
    area: "Perak",
    coordinates: { latitude: 4.7738, longitude: 100.9419 },
  },
  {
    name: "Parit Buntar",
    area: "Perak",
    coordinates: { latitude: 5.1264, longitude: 100.4925 },
  },
  {
    name: "Tanjung Malim",
    area: "Perak",
    coordinates: { latitude: 3.6841, longitude: 101.5213 },
  },
  {
    name: "Sungai Siput",
    area: "Perak",
    coordinates: { latitude: 4.8197, longitude: 101.0744 },
  },
  {
    name: "Slim River",
    area: "Perak",
    coordinates: { latitude: 3.8294, longitude: 101.4025 },
  },
  {
    name: "Bidor",
    area: "Perak",
    coordinates: { latitude: 4.1118, longitude: 101.2882 },
  },
  {
    name: "Gerik",
    area: "Perak",
    coordinates: { latitude: 5.4277, longitude: 101.1278 },
  },
  {
    name: "Lenggong",
    area: "Perak",
    coordinates: { latitude: 5.1051, longitude: 100.9678 },
  },

  // Melaka
  {
    name: "Melaka Tengah",
    area: "Melaka",
    coordinates: { latitude: 2.2227, longitude: 102.2475 },
  },
  {
    name: "Alor Gajah",
    area: "Melaka",
    coordinates: { latitude: 2.3846, longitude: 102.2086 },
  },
  {
    name: "Jasin",
    area: "Melaka",
    coordinates: { latitude: 2.3104, longitude: 102.4312 },
  },
  {
    name: "Ayer Keroh",
    area: "Melaka",
    coordinates: { latitude: 2.2743, longitude: 102.2847 },
  },
  {
    name: "Bukit Katil",
    area: "Melaka",
    coordinates: { latitude: 2.2263, longitude: 102.3013 },
  },
  {
    name: "Merlimau",
    area: "Melaka",
    coordinates: { latitude: 2.1444, longitude: 102.4259 },
  },
  {
    name: "Masjid Tanah",
    area: "Melaka",
    coordinates: { latitude: 2.3512, longitude: 102.1097 },
  },
  {
    name: "Tanjung Kling",
    area: "Melaka",
    coordinates: { latitude: 2.2217, longitude: 102.1625 },
  },

  // Negeri Sembilan
  {
    name: "Seremban",
    area: "Negeri Sembilan",
    coordinates: { latitude: 2.7258, longitude: 101.9424 },
  },
  {
    name: "Nilai",
    area: "Negeri Sembilan",
    coordinates: { latitude: 2.8123, longitude: 101.7905 },
  },
  {
    name: "Port Dickson",
    area: "Negeri Sembilan",
    coordinates: { latitude: 2.5228, longitude: 101.7951 },
  },
  {
    name: "Bahau",
    area: "Negeri Sembilan",
    coordinates: { latitude: 2.8078, longitude: 102.4042 },
  },
  {
    name: "Rembau",
    area: "Negeri Sembilan",
    coordinates: { latitude: 2.5891, longitude: 102.0913 },
  },
  {
    name: "Kuala Pilah",
    area: "Negeri Sembilan",
    coordinates: { latitude: 2.7383, longitude: 102.2486 },
  },
  {
    name: "Tampin",
    area: "Negeri Sembilan",
    coordinates: { latitude: 2.4701, longitude: 102.2302 },
  },
  {
    name: "Rantau",
    area: "Negeri Sembilan",
    coordinates: { latitude: 2.5936, longitude: 101.9619 },
  },
  {
    name: "Senawang",
    area: "Negeri Sembilan",
    coordinates: { latitude: 2.6828, longitude: 101.9723 },
  },
  {
    name: "Mantin",
    area: "Negeri Sembilan",
    coordinates: { latitude: 2.8247, longitude: 101.8924 },
  },

  // Pahang
  {
    name: "Kuantan",
    area: "Pahang",
    coordinates: { latitude: 3.8077, longitude: 103.326 },
  },
  {
    name: "Temerloh",
    area: "Pahang",
    coordinates: { latitude: 3.4506, longitude: 102.4174 },
  },
  {
    name: "Bentong",
    area: "Pahang",
    coordinates: { latitude: 3.5225, longitude: 101.9088 },
  },
  {
    name: "Raub",
    area: "Pahang",
    coordinates: { latitude: 3.7919, longitude: 101.8549 },
  },
  {
    name: "Jerantut",
    area: "Pahang",
    coordinates: { latitude: 3.9361, longitude: 102.3614 },
  },
  {
    name: "Pekan",
    area: "Pahang",
    coordinates: { latitude: 3.4836, longitude: 103.3996 },
  },
  {
    name: "Rompin",
    area: "Pahang",
    coordinates: { latitude: 2.8163, longitude: 103.4824 },
  },
  {
    name: "Cameron Highlands",
    area: "Pahang",
    coordinates: { latitude: 4.4721, longitude: 101.3764 },
  },
  {
    name: "Genting Highlands",
    area: "Pahang",
    coordinates: { latitude: 3.4241, longitude: 101.7932 },
  },
  {
    name: "Fraser's Hill",
    area: "Pahang",
    coordinates: { latitude: 3.7142, longitude: 101.7371 },
  },
  {
    name: "Mentakab",
    area: "Pahang",
    coordinates: { latitude: 3.4832, longitude: 102.3484 },
  },
  {
    name: "Bera",
    area: "Pahang",
    coordinates: { latitude: 3.2384, longitude: 102.4217 },
  },
  {
    name: "Maran",
    area: "Pahang",
    coordinates: { latitude: 3.5855, longitude: 102.7725 },
  },

  // Terengganu
  {
    name: "Kuala Terengganu",
    area: "Terengganu",
    coordinates: { latitude: 5.3302, longitude: 103.1408 },
  },
  {
    name: "Kemaman",
    area: "Terengganu",
    coordinates: { latitude: 4.2379, longitude: 103.4273 },
  },
  {
    name: "Dungun",
    area: "Terengganu",
    coordinates: { latitude: 4.7571, longitude: 103.4111 },
  },
  {
    name: "Marang",
    area: "Terengganu",
    coordinates: { latitude: 5.2045, longitude: 103.2081 },
  },
  {
    name: "Besut",
    area: "Terengganu",
    coordinates: { latitude: 5.7661, longitude: 102.4938 },
  },
  {
    name: "Setiu",
    area: "Terengganu",
    coordinates: { latitude: 5.5683, longitude: 102.7161 },
  },
  {
    name: "Hulu Terengganu",
    area: "Terengganu",
    coordinates: { latitude: 5.1091, longitude: 102.9514 },
  },
  {
    name: "Cukai",
    area: "Terengganu",
    coordinates: { latitude: 4.2307, longitude: 103.4223 },
  },
  {
    name: "Kerteh",
    area: "Terengganu",
    coordinates: { latitude: 4.5091, longitude: 103.4402 },
  },

  // Kelantan
  {
    name: "Kota Bharu",
    area: "Kelantan",
    coordinates: { latitude: 6.1254, longitude: 102.2386 },
  },
  {
    name: "Wakaf Baru",
    area: "Kelantan",
    coordinates: { latitude: 6.1155, longitude: 102.2038 },
  },
  {
    name: "Pasir Mas",
    area: "Kelantan",
    coordinates: { latitude: 6.0416, longitude: 102.1428 },
  },
  {
    name: "Tanah Merah",
    area: "Kelantan",
    coordinates: { latitude: 5.8118, longitude: 102.1455 },
  },
  {
    name: "Kuala Krai",
    area: "Kelantan",
    coordinates: { latitude: 5.5312, longitude: 102.1993 },
  },
  {
    name: "Gua Musang",
    area: "Kelantan",
    coordinates: { latitude: 4.8821, longitude: 101.9682 },
  },
  {
    name: "Bachok",
    area: "Kelantan",
    coordinates: { latitude: 6.0645, longitude: 102.4005 },
  },
  {
    name: "Pasir Puteh",
    area: "Kelantan",
    coordinates: { latitude: 5.8333, longitude: 102.4 },
  },
  {
    name: "Tumpat",
    area: "Kelantan",
    coordinates: { latitude: 6.1979, longitude: 102.1668 },
  },
  {
    name: "Machang",
    area: "Kelantan",
    coordinates: { latitude: 5.7634, longitude: 102.2141 },
  },
  {
    name: "Jeli",
    area: "Kelantan",
    coordinates: { latitude: 5.6983, longitude: 101.8437 },
  },

  // Kedah
  {
    name: "Alor Setar",
    area: "Kedah",
    coordinates: { latitude: 6.121, longitude: 100.3601 },
  },
  {
    name: "Sungai Petani",
    area: "Kedah",
    coordinates: { latitude: 5.6433, longitude: 100.4916 },
  },
  {
    name: "Langkawi",
    area: "Kedah",
    coordinates: { latitude: 6.35, longitude: 99.8 },
  },
  {
    name: "Kulim",
    area: "Kedah",
    coordinates: { latitude: 5.3708, longitude: 100.5547 },
  },
  {
    name: "Baling",
    area: "Kedah",
    coordinates: { latitude: 5.6766, longitude: 100.9169 },
  },
  {
    name: "Pendang",
    area: "Kedah",
    coordinates: { latitude: 5.9922, longitude: 100.4795 },
  },
  {
    name: "Pokok Sena",
    area: "Kedah",
    coordinates: { latitude: 6.1668, longitude: 100.5173 },
  },
  {
    name: "Kota Setar",
    area: "Kedah",
    coordinates: { latitude: 6.121, longitude: 100.3601 },
  },
  {
    name: "Kubang Pasu",
    area: "Kedah",
    coordinates: { latitude: 6.4312, longitude: 100.4285 },
  },
  {
    name: "Padang Terap",
    area: "Kedah",
    coordinates: { latitude: 6.3475, longitude: 100.6728 },
  },
  {
    name: "Bandar Baharu",
    area: "Kedah",
    coordinates: { latitude: 5.1328, longitude: 100.4975 },
  },
  {
    name: "Yan",
    area: "Kedah",
    coordinates: { latitude: 5.8016, longitude: 100.3734 },
  },

  // Perlis
  {
    name: "Kangar",
    area: "Perlis",
    coordinates: { latitude: 6.4414, longitude: 100.1986 },
  },
  {
    name: "Arau",
    area: "Perlis",
    coordinates: { latitude: 6.4297, longitude: 100.2748 },
  },
  {
    name: "Padang Besar",
    area: "Perlis",
    coordinates: { latitude: 6.6622, longitude: 100.3235 },
  },
  {
    name: "Wang Kelian",
    area: "Perlis",
    coordinates: { latitude: 6.6784, longitude: 100.1873 },
  },

  // Sabah
  {
    name: "Kota Kinabalu",
    area: "Sabah",
    coordinates: { latitude: 5.9804, longitude: 116.0735 },
  },
  {
    name: "Sandakan",
    area: "Sabah",
    coordinates: { latitude: 5.8394, longitude: 118.1132 },
  },
  {
    name: "Tawau",
    area: "Sabah",
    coordinates: { latitude: 4.2448, longitude: 117.8912 },
  },
  {
    name: "Lahad Datu",
    area: "Sabah",
    coordinates: { latitude: 5.027, longitude: 118.3308 },
  },
  {
    name: "Keningau",
    area: "Sabah",
    coordinates: { latitude: 5.337, longitude: 116.1595 },
  },
  {
    name: "Semporna",
    area: "Sabah",
    coordinates: { latitude: 4.4815, longitude: 118.5983 },
  },
  {
    name: "Beaufort",
    area: "Sabah",
    coordinates: { latitude: 5.3473, longitude: 115.7455 },
  },
  {
    name: "Kudat",
    area: "Sabah",
    coordinates: { latitude: 6.8831, longitude: 116.8257 },
  },
  {
    name: "Kota Belud",
    area: "Sabah",
    coordinates: { latitude: 6.3534, longitude: 116.4305 },
  },
  {
    name: "Ranau",
    area: "Sabah",
    coordinates: { latitude: 5.9525, longitude: 116.6661 },
  },
  {
    name: "Papar",
    area: "Sabah",
    coordinates: { latitude: 5.7333, longitude: 115.9333 },
  },
  {
    name: "Penampang",
    area: "Sabah",
    coordinates: { latitude: 5.9142, longitude: 116.1005 },
  },
  {
    name: "Putatan",
    area: "Sabah",
    coordinates: { latitude: 5.895, longitude: 116.0505 },
  },
  {
    name: "Tuaran",
    area: "Sabah",
    coordinates: { latitude: 6.1794, longitude: 116.2335 },
  },
  {
    name: "Kota Marudu",
    area: "Sabah",
    coordinates: { latitude: 6.4951, longitude: 116.7644 },
  },
  {
    name: "Beluran",
    area: "Sabah",
    coordinates: { latitude: 5.8943, longitude: 117.5562 },
  },
  {
    name: "Likas",
    area: "Sabah",
    coordinates: { latitude: 5.9866, longitude: 116.1011 },
  },
  {
    name: "Api-Api",
    area: "Sabah",
    coordinates: { latitude: 5.978, longitude: 116.0725 },
  },

  // Sarawak
  {
    name: "Kuching",
    area: "Sarawak",
    coordinates: { latitude: 1.5535, longitude: 110.3593 },
  },
  {
    name: "Miri",
    area: "Sarawak",
    coordinates: { latitude: 4.3995, longitude: 113.9914 },
  },
  {
    name: "Sibu",
    area: "Sarawak",
    coordinates: { latitude: 2.2873, longitude: 111.8305 },
  },
  {
    name: "Bintulu",
    area: "Sarawak",
    coordinates: { latitude: 3.1761, longitude: 113.0416 },
  },
  {
    name: "Limbang",
    area: "Sarawak",
    coordinates: { latitude: 4.7554, longitude: 115.0135 },
  },
  {
    name: "Sarikei",
    area: "Sarawak",
    coordinates: { latitude: 2.1281, longitude: 111.516 },
  },
  {
    name: "Sri Aman",
    area: "Sarawak",
    coordinates: { latitude: 1.2333, longitude: 111.45 },
  },
  {
    name: "Kapit",
    area: "Sarawak",
    coordinates: { latitude: 2.0167, longitude: 112.9333 },
  },
  {
    name: "Mukah",
    area: "Sarawak",
    coordinates: { latitude: 2.8936, longitude: 112.0935 },
  },
  {
    name: "Betong",
    area: "Sarawak",
    coordinates: { latitude: 1.4111, longitude: 111.5273 },
  },
  {
    name: "Serian",
    area: "Sarawak",
    coordinates: { latitude: 1.1691, longitude: 110.5689 },
  },
  {
    name: "Kota Samarahan",
    area: "Sarawak",
    coordinates: { latitude: 1.4646, longitude: 110.4952 },
  },
  {
    name: "Lawas",
    area: "Sarawak",
    coordinates: { latitude: 4.8569, longitude: 115.4055 },
  },
  {
    name: "Marudi",
    area: "Sarawak",
    coordinates: { latitude: 4.1795, longitude: 114.3255 },
  },
  {
    name: "Bau",
    area: "Sarawak",
    coordinates: { latitude: 1.4167, longitude: 110.15 },
  },
  {
    name: "Lundu",
    area: "Sarawak",
    coordinates: { latitude: 1.6751, longitude: 109.8495 },
  },
  {
    name: "Padawan",
    area: "Sarawak",
    coordinates: { latitude: 1.3, longitude: 110.3333 },
  },

  // Labuan
  {
    name: "Labuan",
    area: "Labuan",
    coordinates: { latitude: 5.2831, longitude: 115.2443 },
  },
  {
    name: "Victoria",
    area: "Labuan",
    coordinates: { latitude: 5.2767, longitude: 115.2417 },
  },
];

// Legacy export for backward compatibility
export const KLANG_VALLEY_LOCATIONS = MALAYSIA_LOCATIONS.filter((loc) =>
  [
    "Kuala Lumpur",
    "Petaling Jaya",
    "Subang Jaya",
    "Shah Alam",
    "Klang",
    "Puchong",
    "Cheras",
    "Ampang",
  ].includes(loc.area),
);

function toRadians(degrees) {
  return degrees * (Math.PI / 180);
}

export function calculateDistanceKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

export function coordinatesToNearestArea(latitude, longitude) {
  let nearestLocation = null;
  let shortestDistance = Infinity;

  MALAYSIA_LOCATIONS.forEach((loc) => {
    const d = calculateDistanceKm(
      latitude,
      longitude,
      loc.coordinates.latitude,
      loc.coordinates.longitude,
    );
    if (d < shortestDistance) {
      shortestDistance = d;
      nearestLocation = loc;
    }
  });

  return nearestLocation;
}

/**
 * Sub-area string for URL/filters (must match township strings in malaysiaLocations STATE_TO_AREAS).
 * Each MALAYSIA_LOCATIONS entry has `name` (township) and `area` (state umbrella); geo must use `name`.
 */
export function resolvedAreaSlugFromNearest(nearest) {
  if (!nearest) return "";
  return nearest.name || nearest.area || "";
}
